import React, { useState, useEffect } from 'react';
import CallsList from './components/CallsList';
import 'bootstrap/dist/css/bootstrap.min.css';
import Logout from "./components/logout";
import { gapi } from 'gapi-script';
import AuthCard from './components/authCard';
import './App.css';
import logo from './logo.png';

const clientId = '508890783137-6r2bcmgrbhcr9dciqlpqog8998561mku.apps.googleusercontent.com';

function App() {
  const [isUserSignedIn, setIsUserSignedIn] = useState(false);
  const [userName, setUserName] = useState('');

  useEffect(() => {
    function start() {
      gapi.client.init({
        clientId: clientId,
        scope: "email"
      }).then(() => {
        const auth = gapi.auth2.getAuthInstance();
        auth.isSignedIn.listen(updateSigninStatus);
        updateSigninStatus(auth.isSignedIn.get());
      });
    }

    gapi.load('client:auth2', start);
  }, []);

  const updateSigninStatus = (isSignedIn) => {
    setIsUserSignedIn(isSignedIn);
    if (isSignedIn) {
      const user = gapi.auth2.getAuthInstance().currentUser.get();
      const profile = user.getBasicProfile();
      setUserName(profile.getName());
    } else {
      setUserName('');
    }
  }

  return (
    <div className="App">
      {!isUserSignedIn ? (
        <>
          <header>
            <img src={logo} alt='logo' className='logo' />
            Welcome! Log in to continue to the application.
          </header>
          <AuthCard
            onLogin={() => updateSigninStatus(true)}
            onLogout={() => updateSigninStatus(false)}
          />
        </>
      ) : (
        <>
          <header style={{ textAlign: 'center' }}>
            <img src={logo} alt='logo' className='logo' style={{ marginLeft: '0' }} />
            Welcome {userName}!
          </header>
          <br/>
          <CallsList userName={userName} />
          <br></br>
          <Logout onLogout={() => updateSigninStatus(false)} style={{ backgroundColor: '#d3adf7', borderRadius: '20px', paddingleft: '16px', color: 'white' }}/>
          <br></br>
          <footer>
            <p style={{ fontSize: '17px', marginBottom: '5px' }}>Check out our website: <a href="https://themaydayproject.co">The Mayday Project: Revolutionizing Emergency Response through AI</a></p>
          </footer>
        </>
      )}
    </div>
  );
}

export default App;